import * as ActionTypes from "./websiteAppearanceActionType";

const initialState = {
    isLoading: false,
    appearance: null,
};

export const websiteAppearanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_WEBSITE_APPEARANCE:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.GET_WEBSITE_APPEARANCE_FAILURE:
            return {
                ...state,
                isLoading: false,
            };

        case ActionTypes.GET_WEBSITE_APPEARANCE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                appearance: action?.payload?.data || null,
            };

        default:
            return state;
    }
};
